// Entity type stored on the backend company record and exposed on the user payload.
export const VIEWER_MEMBER = "viewer_member";

export const getEntityType = (user) =>
  String(user?.entity_type || user?.company?.entity_type || "")
    .trim()
    .toLowerCase();

// Viewer Members may read tenders but never create, edit or submit offers.
export const isViewerMember = (user) => getEntityType(user) === VIEWER_MEMBER;
